import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import s from './MatchStatsList.scss';
import CricketPlayerCard from '../CricketTeamList/CricketPlayerCard';
import { TOI_IMAGE_DOMAIN } from '../../../../../constants/index';

const MatchStatsList = props => {
  if (props) {
    const {
      matchStatsData,
      teamaid,
      teambid,
      teamashrt_name,
      teambshrt_name,
      teamaname,
      teambname,
      thumbslist,
    } = props;
    let headToHeadData;
    let topPerformersTeama;
    let topPerformersTeamb;

    const defaultThumb = `${TOI_IMAGE_DOMAIN}/thumb/msid-81945120,width-100,height-100/81945120.jpg`;
    // const [thumbslist, SetThumbslist] = useState(null);
    const getHeadData = () => {
      const team =
        matchStatsData && matchStatsData ? matchStatsData[teamaid] : undefined;
      const headData = team?.overall?.performance_against?.team;
      if (Array.isArray(headData) && headData.length > 0) {
        headData.filter(value => {
          if (value.id === teambid) {
            headToHeadData = value;
          }
          return value;
        });
      }
      const teama = matchStatsData ? matchStatsData[teamaid] : undefined;
      topPerformersTeama =
        teama?.overall?.last_twelve_months?.top_performer?.record;
      const teamb = matchStatsData ? matchStatsData[teambid] : undefined;
      topPerformersTeamb =
        teamb?.overall?.last_twelve_months?.top_performer?.record;
    };
    getHeadData();
    return (
      <>
        {matchStatsData && (
          <>
            <div className={s.teamDetail}>
              <div className={s.left}>
                <div className={s.flag}>
                  <i
                    className={`${
                      s[teamashrt_name ? teamashrt_name.toUpperCase() : '']
                    } ${s.flagIcon}`}
                  />
                </div>
                <strong>{teamashrt_name}</strong>
              </div>
              <div className={s.right}>
                <strong>{teambshrt_name}</strong>
                <div className={s.flag}>
                  <i
                    className={`${
                      s[teambshrt_name ? teambshrt_name.toUpperCase() : '']
                    } ${s.flagIcon}`}
                  />
                </div>
              </div>
            </div>
            <div className={s.teamDetailArea}>
              {matchStatsData[teamaid]?.ranking !== '-' &&
                matchStatsData[teambid]?.ranking !== '-' && (
                  <>
                    <div className={s.secTitle}>
                      <strong>
                        {matchStatsData[teamaid]?.comp_type} Ranking
                      </strong>
                    </div>
                    <div className={s.scoreArea}>
                      <div className={s.left}>
                        {matchStatsData[teamaid] && (
                          <span>{matchStatsData[teamaid].ranking}</span>
                        )}
                      </div>
                      <div className={s.right}>
                        {matchStatsData[teambid] && (
                          <span>{matchStatsData[teambid].ranking}</span>
                        )}
                      </div>
                    </div>
                  </>
                )}
              <div className={s.secTitle}>
                <h2>
                  {teamashrt_name ? teamashrt_name.toUpperCase() : ''} vs{' '}
                  {teambshrt_name ? teambshrt_name.toUpperCase() : ''} Head to
                  Head
                </h2>
              </div>
              <div className={s.scoreArea}>
                <ul className={s.data}>
                  <li>
                    <span>{headToHeadData?.matches_won}</span>
                    <strong>{teamaname} Won</strong>
                  </li>
                  <li>
                    <span>{headToHeadData?.matches_played}</span>
                    <strong>Played</strong>
                  </li>
                  <li>
                    <span>{headToHeadData?.matches_lost}</span>
                    <strong>{teambname} Won</strong>
                  </li>
                </ul>
              </div>
              <div className={s.secTitle}>
                <strong>Performance in Last 1 Year</strong>
              </div>
              <div className={s.statsArea}>
                <div className={s.left}>
                  <ul className={s.data}>
                    <li>
                      {matchStatsData[teamaid] &&
                        matchStatsData[teamaid].overall &&
                        matchStatsData[teamaid].overall.last_twelve_months &&
                        matchStatsData[teamaid].overall.last_twelve_months
                          .matches_played && (
                          <>
                            <span>
                              {
                                matchStatsData[teamaid].overall
                                  .last_twelve_months.matches_played
                              }
                            </span>
                            <strong>Played</strong>
                          </>
                        )}
                    </li>
                    <li>
                      {matchStatsData[teamaid] &&
                        matchStatsData[teamaid].overall &&
                        matchStatsData[teamaid].overall.last_twelve_months &&
                        matchStatsData[teamaid].overall.last_twelve_months
                          .matches_won && (
                          <>
                            <span>
                              {
                                matchStatsData[teamaid].overall
                                  .last_twelve_months.matches_won
                              }
                            </span>
                            <strong>Win</strong>
                          </>
                        )}
                    </li>
                    <li>
                      {matchStatsData[teamaid] &&
                        matchStatsData[teamaid].overall &&
                        matchStatsData[teamaid].overall.last_twelve_months &&
                        matchStatsData[teamaid].overall.last_twelve_months
                          .matches_lost && (
                          <>
                            <span>
                              {
                                matchStatsData[teamaid].overall
                                  .last_twelve_months.matches_lost
                              }
                            </span>
                            <strong>Lost</strong>
                          </>
                        )}
                    </li>
                    <li>
                      {matchStatsData[teamaid] &&
                        matchStatsData[teamaid].overall &&
                        matchStatsData[teamaid].overall.last_twelve_months &&
                        matchStatsData[teamaid].overall.last_twelve_months
                          .win_percentage && (
                          <>
                            <span>
                              {
                                matchStatsData[teamaid].overall
                                  .last_twelve_months.win_percentage
                              }
                            </span>
                            <strong>Win%</strong>
                          </>
                        )}
                    </li>
                  </ul>
                </div>
                <div className={s.right}>
                  <ul className={s.data}>
                    <li>
                      {matchStatsData[teambid] &&
                        matchStatsData[teambid].overall &&
                        matchStatsData[teambid].overall.last_twelve_months &&
                        matchStatsData[teambid].overall.last_twelve_months
                          .matches_played && (
                          <>
                            <span>
                              {
                                matchStatsData[teambid].overall
                                  .last_twelve_months.matches_played
                              }
                            </span>
                            <strong>Played</strong>
                          </>
                        )}
                    </li>
                    <li>
                      {matchStatsData[teambid] &&
                        matchStatsData[teambid].overall &&
                        matchStatsData[teambid].overall.last_twelve_months &&
                        matchStatsData[teambid].overall.last_twelve_months
                          .matches_won && (
                          <>
                            <span>
                              {
                                matchStatsData[teambid].overall
                                  .last_twelve_months.matches_won
                              }
                            </span>
                            <strong>Win</strong>
                          </>
                        )}
                    </li>

                    <li>
                      {matchStatsData[teambid] &&
                        matchStatsData[teambid].overall &&
                        matchStatsData[teambid].overall.last_twelve_months &&
                        matchStatsData[teambid].overall.last_twelve_months
                          .matches_lost && (
                          <>
                            <span>
                              {
                                matchStatsData[teambid].overall
                                  .last_twelve_months.matches_lost
                              }
                            </span>
                            <strong>Lost</strong>
                          </>
                        )}
                    </li>
                    <li>
                      {matchStatsData[teambid] &&
                        matchStatsData[teambid].overall &&
                        matchStatsData[teambid].overall.last_twelve_months &&
                        matchStatsData[teambid].overall.last_twelve_months
                          .win_percentage && (
                          <>
                            <span>
                              {
                                matchStatsData[teambid].overall
                                  .last_twelve_months.win_percentage
                              }
                            </span>
                            <strong>Win%</strong>
                          </>
                        )}
                    </li>
                  </ul>
                </div>
              </div>
              <div className={s.secTitle}>
                <strong>Top Performers in Last 1 Year</strong>
              </div>
              <div className={s.topPerformers}>
                <div className={s.left}>
                  <ul>
                    {topPerformersTeama &&
                      topPerformersTeama.map(value => {
                        let playerkey = value && value.name;
                        playerkey =
                          (playerkey &&
                            playerkey
                              .split(' ')
                              .join('-')
                              .toUpperCase()) ||
                          null;
                        return (
                          <li>
                            <CricketPlayerCard
                              items={{
                                short_name: value.name,
                                skill_name: value.type,
                                top_score: value.value,
                              }}
                              defaultThumb={defaultThumb}
                              playerkey={playerkey}
                              thumbslist={thumbslist || ''}
                            />
                          </li>
                        );
                      })}
                  </ul>
                </div>
                <div className={s.right}>
                  <ul>
                    {topPerformersTeamb &&
                      topPerformersTeamb.map(value => {
                        let playerkey = value && value.name;
                        playerkey =
                          (playerkey &&
                            playerkey
                              .split(' ')
                              .join('-')
                              .toUpperCase()) ||
                          null;
                        return (
                          <li>
                            <CricketPlayerCard
                              items={{
                                short_name: value.name,
                                skill_name: value.type,
                                top_score: value.value,
                              }}
                              defaultThumb={defaultThumb}
                              playerkey={playerkey}
                              thumbslist={thumbslist || ''}
                            />
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
            </div>
          </>
        )}
        {!matchStatsData && <div />}
      </>
    );
  }
  return null;
};
MatchStatsList.propTypes = {
  matchStatsData: PropTypes.objectOf([]),
  deviceType: PropTypes.string,
};
MatchStatsList.defaultProps = {
  matchStatsData: [],
  deviceType: '',
};

export default MatchStatsList;
